import {SlottedTimeValue} from '../SlottedTimeValue';
import {useState,useEffect} from "react";
import {initJSON} from "../../../../../vendor/tangible/fields/assets/src/utils";
export const IssuanceTrainingCodes = props => {

  const scheduledTypesArgs = window.tgblCredScheduledTypesArgs
  const title = props.title ?? 'Training Codes'
  const name = props.name ?? 'training_codes'

  return (
    <>
      { props.value.length === 0  &&
        <h5>{title}</h5>
      }
      <SlottedTimeValue {...{
        name,
        title,
        slots: props.value ?? [],
        slotValueFieldDefinitions: [{
          type: 'text', name: 'code', label: 'Code', placeholder: ''
        }],
        scheduledTypesArgs,
        onChange: props.onChange?.bind()
      }}
      ></SlottedTimeValue>
    </>
  )

}
